import type VersionControlProperties from './VersionControl.properties.ts';
import { lsClear, lsLoad } from '../../tools/Storage.ts';
import StorageEnum from '../../enums/Storage.enum.ts';
import { getVersion } from '../../tools/ConfigurationReader.ts';
import { reloadPage } from '../../tools/Routing.ts';
import { VersionControlContext } from './VerrsionControl.context.tsx';
import { useCallback, useEffect } from 'react';
import { useLogging } from '../logging/Logging.hook.ts';
import { toast } from 'react-toastify';
import { toastOptions } from '../../tools/helpers/ToastHelper.ts';
import { useTranslation } from 'react-i18next';

export const VersionControlProvider = (props: VersionControlProperties) => {
  const { logInfo } = useLogging();
  const { t } = useTranslation();

  const verifyVersion = useCallback(() => {
    const currentVersion = lsLoad(StorageEnum.Version);

    if (currentVersion !== getVersion()) {
      logInfo('version has been changed, reload page and logout', 'VersionControlProvider', () => {
        toast.warning(t('ui.versionChanges'), {
          ...toastOptions,
          onClose: () => {
            lsClear();
            reloadPage();
          },
        });
      });
    }
  }, [logInfo, t]);

  useEffect(() => {
    verifyVersion();

    const interval = setInterval(
      () => {
        verifyVersion();
      },
      5 * 60 * 1000
    ); // every 5 minutes

    return () => clearInterval(interval);
  }, [verifyVersion]);

  return (
    <VersionControlContext.Provider value={null}>{props.children}</VersionControlContext.Provider>
  );
};
